import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useStoryBlokStore } from "./storyblok";


export const usePartnersStore = defineStore('partners', () => {

  const storyBlockStore = useStoryBlokStore();


  const partnersStory = computed(() => {
    if (storyBlockStore.body === undefined) return undefined;

    return storyBlockStore.body.find(bodyElements => bodyElements.component === 'partners');
  });

  const partnerGroup = computed(() => {
    if (partnersStory.value === undefined) return undefined;
    return partnersStory.value.partnergroup;
  });

  const generalPartners = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'general-partners').partners;
  });

  const generalPartnersShown = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'general-partners').shown;
  });

  const patrons = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'patrons').partners;
  });

  const patronsShown = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'patrons').shown;
  });

  const mainPartners = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'main-partners').partners;
  });

  const mainPartnersShown = computed(() => {
    if (partnerGroup.value === undefined) return false;

    return partnerGroup.value.find(bodyElements => bodyElements.id === 'main-partners').shown;
  });

  const partners = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'partners').partners;
  });

  const partnersShown = computed(() => {
    if (partnerGroup.value === undefined) return false;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'partners').shown;
  });

  const mediaPartners = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'media-partners').partners;
  });

  const mediaPartnersShown = computed(() => {
    if (partnerGroup.value === undefined) return false;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'media-partners').shown;
  });

  const supportPartners = computed(() => {
    if (partnerGroup.value === undefined) return undefined;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'support-partners').partners;
  });

  const supportPartnersShown = computed(() => {
    if (partnerGroup.value === undefined) return false;
    return partnerGroup.value.find(bodyElements => bodyElements.id === 'support-partners').shown;
  });


  const wholePartnersSectionShown = computed(() => {
    if (partnersStory.value === undefined) return false;

    return partnersStory.value.shown;
  });

  return { wholePartnersSectionShown, mainPartnersShown, mainPartners, partners, partnersShown, mediaPartners, mediaPartnersShown, supportPartners, supportPartnersShown, generalPartners, generalPartnersShown, patrons, patronsShown }
});
